import {useContext} from 'react';
import {MapContext} from '../../../apiContexts';

// Um relatorio aberto no mapa (route/trip/event/journey_trip/...) deve isolar o trajeto --
// misturado com dispositivo/alarme/label/trilha ao vivo, o relatorio fica ilegivel. MapContext.data
// e o mesmo sinal que useMapReport ja consome (RouteReportContainer e afins chamam setData nele).
const useReportActive = () => {
  const context = useContext(MapContext) || {};
  return Boolean(context.data && context.data.type);
};

export default useReportActive;
